import React from 'react';
import { CustomDropdown } from '../custom-dropdown/CustomDropdown';

export const TypeDropdown = ({ label, options, onChange, value }) => (
    <CustomDropdown
        label={label}
        options={options}
        onChange={change => onChange(change.value)}
        value={value}
    />
);
